import React from 'react';
import './VideoGallery.scss';
import { IVideoModel } from '../../core/types';

interface IProps {
  data: IVideoModel[];
  renderItem: (video: IVideoModel, index: number) => React.ReactNode;
  placeholder?: React.ReactNode;
  profile?: boolean;
}

const VideoGallery = ({ data, renderItem, placeholder, profile }: IProps) => {
  return (
    <div className='VideoGallery container'>
      <div className={`row g-2 ${profile && 'VideoGallery--profile'}`}>
        {data && data.length
          ? data.map((video, index) => {
              return renderItem(video, index);
            })
          : placeholder ?? (
              <div className='VideoGallery__noClips'> There are no clips.</div>
            )}
      </div>
    </div>
  );
};

export default VideoGallery;
